import { Component, Input, OnInit } from '@angular/core';
import { PghUserDeviceBase } from '../pgh-user-device';
import { SelectedDeviceService } from '../selected-device.service';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-device-breadcrumbs',
  templateUrl: './device-breadcrumbs.component.html',
  styleUrls: ['./device-breadcrumbs.component.scss']
})
export class DeviceBreadcrumbsComponent implements OnInit {

  public selectedDevice?: PghUserDeviceBase;
  public myDeviceRoute: string;
  public deviceDetailsRoute: string;
  public isSPOEEnabled: boolean = false;

  @Input() deviceContentPageTitle?: string;
  @Input() deviceSearchAddPageTitle?: string;


  public constructor(
    private selectedDeviceService: SelectedDeviceService,
    public resourceService: ADPResourceService,
  ) { }

  public ngOnInit(): void {
    this.myDeviceRoute = this.resourceService.getPortalSetting("URL_MyDevices")?.Value;
    this.deviceDetailsRoute = localStorage.getItem('device-detail-url');
    this.selectedDevice = this.selectedDeviceService.getSelectedDevice();
    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }


}
